import { DefaultSingleConnectionConnectProcessor } from './default-single-connection-connect.processor';
import { DynamicLabelingArticleConnectProcessor } from './dynamic-labeling-article-connect.processor';
import { BusbarArticleConnectProcessor } from './busbar-article-connect.processor';
import { LabelingArticleConnectProcessor } from './labeling-article-connect.processor';
import { WireBridgeArticleConnectProcessor } from './wire-bridge-article-connect.processor';
import { UnusedLabelingArticleConnectProcessor } from './unused-labeling-article-connect.processor';
import { UnusedDynamicLabelingArticleConnectProcessor } from './unused-dynamic-labeling-article-connect.processor';
import { DefaultMultipleConnectionConnectProcessor } from './default-multiple-connection-connect.processor';
import { BridgeArticleConnectProcessor } from './bridge-article-connect.processor';
import { ArticleConnectProcessorRegistry } from './article-connect-processor-registry';
import { Injectable } from '@angular/core';

@Injectable({providedIn: 'root'})
export class ArticleConnectProcessorRegistryInitializer {
  constructor(
    private articleConnectProcessorRegistry: ArticleConnectProcessorRegistry,
    private defaultSingleConnectProcessor: DefaultSingleConnectionConnectProcessor,
    private dynamicLabelingArticleConnectProcessor: DynamicLabelingArticleConnectProcessor,
    private busbarArticleConnectProcessor: BusbarArticleConnectProcessor,
    private labelingConnectProcessor: LabelingArticleConnectProcessor,
    private wireBridgeConnectProcessor: WireBridgeArticleConnectProcessor,
    private unusedLabelingConnectProcessor: UnusedLabelingArticleConnectProcessor,
    private unusedDynamicLabelingArticleConnectProcessor: UnusedDynamicLabelingArticleConnectProcessor,
    // prepare processors to connect article by multiple giving connections:
    private defaultMultipleConnectProcessor: DefaultMultipleConnectionConnectProcessor,
    private bridgeConnectProcessor: BridgeArticleConnectProcessor,
  ) {}

  public initialize() {
    this.articleConnectProcessorRegistry.initialize(
      this.defaultSingleConnectProcessor,
      this.dynamicLabelingArticleConnectProcessor,
      this.busbarArticleConnectProcessor,
      this.labelingConnectProcessor,
      this.wireBridgeConnectProcessor,
      this.unusedLabelingConnectProcessor,
      this.unusedDynamicLabelingArticleConnectProcessor,
      // prepare processors to connect article by multiple giving connections:
      this.defaultMultipleConnectProcessor,
      this.bridgeConnectProcessor);
  }
}
